import styled, { css } from 'styled-components';
import { AvatarStyled } from '@bechtel/gds';
export const AddCrewIconStyled = styled(AvatarStyled)`
  justify-content: center;
  ${({ theme }) => css`
    background-color: ${theme.colors.blue[100]};
    border: 1px solid ${theme.colors.white};
  `};
`;
